var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M15.252 6.99023C17.2945 6.99023 18.957 8.70673 18.957 10.8164V15.01C18.957 17.1146 17.2987 18.8267 15.2604 18.8267H5.99703C3.9537 18.8267 2.29036 17.1111 2.29036 15.0014V10.8078C2.29036 8.70329 3.94953 6.99023 5.9887 6.99023H6.77203L15.252 6.99023Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M10.1681 3.18368L7.74393 5.65694C7.49393 5.91256 7.49393 6.32392 7.7456 6.57869C7.99727 6.83262 8.4031 6.83178 8.6531 6.577L9.9806 5.22272V13.8131C9.9806 14.1728 10.2681 14.4648 10.6231 14.4648C10.9773 14.4648 11.2639 14.1728 11.2639 13.8131V5.22272L12.5923 6.577C12.8423 6.83178 13.2481 6.83262 13.4998 6.57869C13.6256 6.45088 13.6889 6.28414 13.6889 6.11655C13.6889 5.95065 13.6256 5.7839 13.5014 5.65694L11.0773 3.18368C10.9564 3.06095 10.7931 2.99154 10.6231 2.99154C10.4523 2.99154 10.2889 3.06095 10.1681 3.18368Z",
    fill: "#E5B910"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletUpload);
export default __webpack_public_path__ + "static/media/wallet-upload.c74caf9e8406ea86562bcc72e7d1aa94.svg";
export { ForwardRef as ReactComponent };